import React from 'react'
import {trans} from 'Src/utilities/Helpers'

const Footer = () => {
  return (
    <div className="tw-text-xs tw-text-brand-body_text--muted">
      <p className="tw-mx-6 tw-my-2">
        <span className="required-asterisk">*</span> {trans('required_field')}
      </p>
    </div>
  )
}

export default Footer
